module.exports = __webpack_public_path__ + "static/img/reference pics_YFY UASB2.d00b4227.jpg";